import React from "react"
import styled from "styled-components"
import DarkThemeIcon from "./SVG/DarkTheme"

export const StyledDarkThemeIcon = styled.div`
  fill: ${({ theme }) => ("darkTheme" ? theme.headerSubtitle : theme.sidebarBackground)} !important;
  cursor: pointer;
  margin: 0 16px;
  &:hover {
    fill: #5d9bff !important;
  }
`

const Toggle = ({ theme, toggleTheme }) => {
  return (
    <StyledDarkThemeIcon theme={theme} onClick={toggleTheme}>
      <DarkThemeIcon />
    </StyledDarkThemeIcon>
  )
}

export default Toggle
